export type WebappTheme = 'CAKE' | 'DEFICHAIN';

export const isDefiChainTheme = (theme: WebappTheme) => theme === 'DEFICHAIN';
